import { uuidv7 } from 'uuidv7';
import { pushVideoDebugLogEntry } from '@/lib/videoDebug';

export type LogLevel = 'info' | 'warn' | 'error';

export type LogEvent = {
  ts: string;
  level: LogLevel;
  service: string;
  env: string;
  event: string;
  trace_id: string;
  msg: string;
  [key: string]: unknown;
};

const TRACE_ID_KEY = 'dwellbot_trace_id';
let cachedTraceId: string | null = null;

export const getTraceId = (): string => {
  if (cachedTraceId) {
    return cachedTraceId;
  }
  if (typeof sessionStorage !== 'undefined') {
    const existing = sessionStorage.getItem(TRACE_ID_KEY);
    if (existing) {
      cachedTraceId = existing;
      return existing;
    }
    const created = uuidv7();
    sessionStorage.setItem(TRACE_ID_KEY, created);
    cachedTraceId = created;
    return created;
  }
  cachedTraceId = uuidv7();
  return cachedTraceId;
};

const baseFields = () => ({
  service: 'play-claw',
  env: import.meta.env.MODE || 'local',
});

export const logEvent = (level: LogLevel, event: string, msg: string, fields?: Record<string, unknown>) => {
  const payload: LogEvent = {
    ts: new Date().toISOString(),
    level,
    event,
    trace_id: getTraceId(),
    msg,
    ...baseFields(),
    ...(fields || {}),
  };
  let detail: string | undefined;
  if (fields && Object.keys(fields).length > 0) {
    try {
      detail = JSON.stringify(fields);
    } catch {
      detail = '[fields_unserializable]';
    }
  }
  pushVideoDebugLogEntry({
    ts: payload.ts,
    level: payload.level,
    source: 'app',
    event: payload.event,
    msg: payload.msg,
    traceId: payload.trace_id,
    detail,
  });
  return payload;
};

export const logInfo = (event: string, msg: string, fields?: Record<string, unknown>) =>
  logEvent('info', event, msg, fields);

export const logWarn = (event: string, msg: string, fields?: Record<string, unknown>) =>
  logEvent('warn', event, msg, fields);

export const logError = (event: string, msg: string, fields?: Record<string, unknown>) =>
  logEvent('error', event, msg, fields);
